module.exports = __webpack_public_path__ + "static/media/mobile_1.0f865eb0.jpg";